"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getClassName=function(e,r){var t;return(t=Array.isArray(e)?e:Object.keys(e).filter((function(r){return!!e[r]}))).push(r),t.filter((function(e){return!!e})).join(" ")};
//# sourceMappingURL=index.js.map
